















































































import {
	Vue,
	Component,
	PropSync,
	Prop,
	Ref,
} from 'vue-property-decorator'
import type { TurnoDeVenda, UsuarioBase, Venda } from '@/models'
import { formatarDecimal } from '@/shareds/formatadores'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue'
import { FindPerfilUseCase, FindUsuarioUseCase } from '@/usecases'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import { VendaModule } from '@/store/vuex/venda/VendaStore'

@Component({
	components: {
		CampoDecimal,
		CampoDePercentual,
		SeletorDeUsuario,
	},
})
export default class BotaoDeVendedorPorItem extends Vue {
	@PropSync('value') vendedor!: UsuarioBase | null
	@Prop() venda!: Venda
	@Prop() turnoDeVenda!: TurnoDeVenda | null
	@Ref() botaoDeAcaoDeVendedor!: { $el: HTMLButtonElement }
	@Ref() campoDeValor!: CampoDecimal | CampoDePercentual
	@Ref() form!: HTMLFormElement
	@Prop({ type: Boolean }) disabled!: boolean

	findUsuarioUseCase = new FindUsuarioUseCase()
	findPerfilUseCase = new FindPerfilUseCase()

	CampoDePercentual = CampoDePercentual
	CampoDecimal = CampoDecimal

	formatarDecimal = formatarDecimal
	mostraMenuDeVendedor = false

	vendedorEmEdicao: UsuarioBase | null = null

	get vendaAtual() {
		return VendaModule.vendaAtual as Venda
	}

	get bloqueiaMultiplosVendedores(): boolean {
		return (this.vendaAtual.tipoDeTransacao === 'Devolução' || (this.vendaAtual.tipoDeTransacao === 'Outros' && this.vendaAtual.vendaOrigem !== null))
			&& !!this.turnoDeVenda?.pontoDeVenda?.loja?.configuracaoDaLoja?.bloqueiaMultiplosVendedoresNaTroca	}

	get bloqueiaAlteracaoDeVendedorNaDemonstracao(): boolean {
		return !!this.vendaAtual?.isDemonstracao
			&& !!this.turnoDeVenda?.pontoDeVenda?.loja?.configuracaoDaLoja?.naoPermiteAlterarVendedorEmDemonstracoes
	}

	get exigeAutorizacaoParaAlterarVendedor(): boolean {
		return (this.vendaAtual.tipoDeTransacao === 'Devolução' || (this.vendaAtual.tipoDeTransacao === 'Outros' && this.vendaAtual.vendaOrigem !== null))
			&& !!this.turnoDeVenda?.pontoDeVenda?.loja?.configuracaoDaLoja?.exigeAutorizacaoTrocaDeVendedorNaTroca
	}

	async acaoDeVendedor() {
		this.mostraMenuDeVendedor = !this.mostraMenuDeVendedor

		if (this.vendedor) {
			this.vendedorEmEdicao = this.vendedor
		}
	}

	async aplicarVendedor() {
		const vendedorAnterior = this.vendedor

		if (this.exigeAutorizacaoParaAlterarVendedor && this.vendedorEmEdicao?.id !== vendedorAnterior?.id) {
			const resultado = await VendaModule.autenticarAcao({ regra: 'pode-autorizar-troca-de-vendedor' })

			if (!resultado?.autenticado) {
				this.vendedorEmEdicao = vendedorAnterior
				this.mostraMenuDeVendedor = false
				return
			}
		}

		this.vendedor = this.vendedorEmEdicao
		this.mostraMenuDeVendedor = false
	}
}
